<template>
  <div class="choice-work-item">
    <!-- 选择工作项 -->
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('shared.title.selectItemOfWork')">
      <div class="right-header">
        <div
          class="project-filter"
          slot="right"
        >
          <van-popover
            v-model="showPopover"
            trigger="click"
            :actions="actions"
            @select="onSelect"
            placement="left-start"
            get-container=".choice-work-item"
          >
            <template #reference>
              <van-icon name="ellipsis" />
            </template>
          </van-popover>
        </div>
      </div>
      <!-- <div v-if="customerInfo.isAllot !== 0" class="right-header" @click="toPage(`/storeMaintain/storeMappingDetail?customerId=${customerId}&pageType=storeMaintain`)">
        Detail
      </div> -->
    </NavHeaderBar>
    <div class="header-section">
      <div v-if="[1, '1', 2].includes(customerInfo.customerTag)" class="img-bc">
        <img v-if="customerInfo.imgUrl" class="custom-img" :src="customerInfo.imgUrl" alt="" @click.stop="imgPreview(customerInfo.imgUrl)">
        <img v-else class="custom-img" src="@/assets/images/icon_noimg.png" alt="">
        <img v-if="[1, '1'].includes(customerInfo.customerTag)" class="mark-img" src="@/assets/images/u93.png" alt="">
      </div>
      <img v-else-if="customerInfo.imgUrl" class="store-img" :src="customerInfo.imgUrl" alt="" @click.stop="imgPreview(customerInfo.imgUrl)">
      <img v-else class="store-img" src="@/assets/images/icon_noimg.png" alt="">
      <div class="right-info">
        <div class="store-name van-ellipsis">{{ customerInfo.customerName }}</div>
        <div v-if="!['', null].includes(customerInfo.customerTag) || customerInfo.dutyName" class="tag-ba">
          <div v-if="!['', null].includes(customerInfo.customerTag)" class="tag-info van-ellipsis" :class="customerInfo.customerTag | formatTagClass">{{ customerInfo.customerTag | formatTag }}</div>
          <div v-if="customerInfo.dutyName" class="ba-name van-ellipsis">{{ $t('shared.bA') }}：{{ customerInfo.dutyName }}</div>
        </div>
        <div class="product-type" v-if="customerInfo.newShelfList && customerInfo.newShelfList.length > 0">
          <div class="type-info txt-ellipsis">
            <span>({{ customerInfo.newShelfList.length }})</span>
            <span>{{ customerInfo.newShelfList.join(',') }}</span>
          </div>
        </div>
        <!-- Last Activity： -->
        <div v-if="customerInfo.lastOperationType" class="last-activity"><span class="font-color">{{ customerInfo.lastOperationType }}</span> {{ $t('shared.by') }} {{ customerInfo.operationUserName }} <span class="font-color">{{ customerInfo.visitDifferDay | formatTime }}</span> <span v-show="customerInfo.visitDifferDay > 1">{{ $t('shared.daysAgo') }}</span></div>
        <div class="info-row" v-if="customerInfo.address">
          <div class="navigate-info" @click="getCurrentLoc">
            <img src="@/assets/images/daohang_white.png" class="row-icon" alt="">
            <span>{{ $t('button.navigate') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="menu-content">
      <div v-for="(subItem, subIndex) in menuList" :key="subIndex" class="work-item" @click="toUrl(subItem.path, subItem)">
        <div class="work-icon">
          <img :src="subItem.imgIcon" alt="" class="img-icon">
        </div>
        <div class="work-text">{{ subItem.labelVal }}</div>
      </div>
    </div>
    <div class="give-up-content" v-if="customerInfo.audit && this.checkPer(['admin', 'app:customer:giveUp'])">
      <div v-show="!customerInfo.audit.submitStatus" class="fq-btn" @click="handleOper('giveup')">
        <span>{{ $t('shared.kickOutOfOperation') }}</span>
      </div>
      <div v-show="customerInfo.audit.submitStatus" class="fq-btn review">
        <span>{{ $t('shared.kickOutOfOperation') }}</span>
        <span>{{ customerInfo.audit.createUserName }} {{ $t('shared.applicationForKickOutOfOperation') }}</span>
      </div>
    </div>
    <div class="line-split"></div>
    <!-- 门店待办事项 -->
    <div class="log-title">{{ $t('shared.storeToDoItems') }}</div>
    <div v-if="logInfo.length > 0" class="log-content">
      <van-steps class="steps-content" direction="vertical">
        <van-step v-for="item in logInfo" :key="item.id">
          <div slot="active-icon" style="width: 9px; height: 9px; border: 2px solid #307bff; border-radius: 50%; background-color: #fff;"></div>
          <div slot="inactive-icon" style="width: 9px; height: 9px; border: 2px solid #307bff; border-radius: 50%; background-color: #fff;"></div>
          <div class="step-title">
            <span>{{ item.label === 0 ? $t('shared.mapping') : item.label === 1 ? $t('shared.visit') : item.label === 2 ? $t('shared.event') : '' }}</span>
          </div>
          <div class="step-content">
            <div class="step-item" @click="toUrl(item.descUrl, item)">
              <span class="store-name">{{ item.descVal }}</span>
            </div>
          </div>
        </van-step>
        <van-step></van-step>
      </van-steps>
    </div>
    <van-empty v-else description="No Data" />
    <XuVisitDialog ref="xuVisitDialogRef" :currentVisitInfo="currentVisitInfo" :customerId="customerId" :pageType="pageType" />
    <van-popup v-model="giveUpShow" round :style="{ width: '80%' }">
      <div class="fq-dialog-content">
        <div class="dialog-title">{{ $t('shared.kickOutOfOperation') }}</div>
        <div class="customer-name van-ellipsis">{{ $t('shared.store') }}：{{ customerInfo.customerName }}</div>
        <div class="form-item">
          <div class="form-label">{{ $t('shared.titleTwentyFour') }}</div>
          <van-field v-model="giveUpReason" type="textarea" show-word-limit rows="3" class="custom-field field-textarea" />
        </div>
        <div class="tips-item">
          <van-icon name="info-o" size="13" class="info-icon" color="#c4200b" />
          <span>{{ $t('shared.titleTwentyFive') }}.</span>
        </div>
      </div>
      <div class="popup-btn">
        <div class="cancel-btn" @click="handleOper('cancel')">{{ $t('button.cancel') }}</div>
        <div class="submit-btn" @click="handleOper('submit')">{{ $t('button.submitForReview') }}</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { backlogCustomerBacklogApi, auditGiveUpCustomerAuditApi } from '@/api/storeMaintain'
import { arsCustomerInfoApi } from '@/api/home'
import { Toast, ImagePreview, Dialog, Notify } from 'vant'
import { mapState, mapMutations } from 'vuex'
import { arsVisitLastApi } from '@/api/visit'
import i18n from '@/i18n'
export default {
  components: {
    XuVisitDialog: () => import('@/components/XuVisitDialog')
  },
  filters: {
    formatTime (val) {
      if ([null, ''].includes(val)) {
        return ''
      }
      // return moment().diff(moment(val), 'days')
      return val === 0 ? i18n.t('shared.today') : val === 1 ? i18n.t('shared.yesterday') : val
    },
    formatTag (value) {
      return value === 0 ? i18n.t('shared.filter.toBeVerified') : value === 1 ? i18n.t('shared.filter.sVIPCore') : value === 2 ? i18n.t('shared.filter.vIPCore') : value === 3 ? i18n.t('shared.filter.potential') : ''
    },
    formatTagClass (value) {
      return `tag${value}`
    }
  },
  data () {
    return {
      pageType: 'storeMaintain',
      customerId: '',
      logInfo: {},
      customerInfo: {},
      menuList: [
        { label: 'Mapping', labelVal: this.$t('shared.mapping'), imgIcon: require('@/assets/images/mapping.png'), path: '/storeExpansion/storeMapping', auth: 'app:customer:update' },
        { label: 'Visit', labelVal: this.$t('shared.visit'), imgIcon: require('@/assets/images/visit.png'), path: '/storeMaintain/storeVisit', auth: 'app:visit:addOrUpdate' },
        { label: 'Reorder', labelVal: this.$t('shared.reorder'), imgIcon: require('@/assets/images/reorder.png'), path: '/storeMaintain/reOrderVisit', auth: 'app:reorder:addOrUpdate' },
        { label: 'Event Invite', labelVal: this.$t('shared.eventInvite'), imgIcon: require('@/assets/images/event_invite.png'), path: '/createEvent', auth: 'app:event:add' },
        { label: 'Event Execute', labelVal: this.$t('shared.eventExecute'), imgIcon: require('@/assets/images/event_execute.png'), path: '/event', auth: 'app:event' },
        { label: 'Incentive', labelVal: this.$t('shared.title.incentive'), imgIcon: require('@/assets/images/incentive.png'), path: '/storeIncentive', auth: 'app:incentive' }
      ],
      currentVisitInfo: {},
      giveUpShow: false,
      giveUpReason: '',
      showPopover: false
    }
  },
  computed: {
    ...mapState('event', ['eventInfo']),
    actions () {
      const newArr = []
      if (this.customerInfo.isAllot === 1 && this.customerInfo.status === 1) {
        newArr.push({ text: this.$t('shared.title.storeInfo'), icon: require('@/assets/images/record.png'), type: 'detail' })
        newArr.push({ text: this.$t('shared.storeActivity'), icon: require('@/assets/images/map_time.png'), type: 'activity' })
      }
      newArr.push({ text: this.$t('shared.relevantVisitPlans'), icon: require('@/assets/images/record.png'), type: 'plan' })
      return newArr
    }
  },
  activated () {
    this.giveUpReason = ''
    const { customerId } = this.$route.query
    this.customerId = customerId
    this.getLogData()
    this.getCustomerInfo()
  },
  methods: {
    ...mapMutations('event', ['SET_EVENTINFO']),
    onSelect (action, index) {
      if (action.type === 'activity') {
        this.$router.push(`/shared/mappingActivity?customerId=${this.customerInfo.id}`)
      } else if (action.type === 'plan') {
        this.$router.push(`/visitPlan?targetId=${this.customerInfo.id}&targetType=0&pageType=storeMaintain`)
      } else if (action.type === 'detail') {
        this.$router.push(`/storeMaintain/storeMappingDetail?customerId=${this.customerInfo.id}&pageType=storeMaintain`)
      }
    },
    getLogData () {
      backlogCustomerBacklogApi({ customerId: this.customerId }).then(res => {
        res.data.forEach(subItem => {
          subItem.descVal = ''
          subItem.descUrl = ''
          subItem.auth = ''
          if (subItem.label === 0) {

          } else if (subItem.label === 1) {

          } else if (subItem.label === 2) {
            // subItem.descVal = subItem.type === 0 ? '该门店有活动邀约待提报活动，查看邀约信息>' : subItem.type === 1 ? `${subItem.backlogUserName}提报的event${subItem.sourceName}将于${subItem.backlogTime}开始，去查看>` : subItem.type === 2 ? '该门店活动结束后尚未判定门店等级，去提交>' : ''
            // subItem.descVal = subItem.type === 0 ? 'There are event invitations to be Launched at this store. View invitation information >' : subItem.type === 1 ? `${subItem.backlogUserName} The event ${subItem.sourceName} will start at ${subItem.backlogTime}, go to view >` : subItem.type === 2 ? 'The store level has not been determined since the end of the store activity. Go to submit >' : ''
            subItem.descVal = subItem.type === 0 ? `${this.$t('shared.titleTwentySix')} >` : subItem.type === 1 ? `${this.$t('shared.titleTwentySeven', { backlogUserName: subItem.backlogUserName, sourceName: subItem.sourceName, backlogTime: subItem.backlogTime })} >` : subItem.type === 2 ? `${this.$t('shared.titleTwentyEight')} >` : ''
            subItem.descUrl = subItem.type === 0 ? '/createEvent' : subItem.type === 1 ? '/eventDetail' : subItem.type === 2 ? '/eventDetail' : ''
            subItem.auth = 'app:event:add'
          }
        })
        this.logInfo = res.data
      })
    },
    getCustomerInfo () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsCustomerInfoApi(this.customerId).then(res => {
        Toast.clear()
        res.data.newShelfList = res.data.shelfList.filter(shelfItem => shelfItem.isShelf === 1)
        res.data.newShelfList = res.data.newShelfList.map(shelfItem => shelfItem.productName)
        this.customerInfo = res.data
      }).catch(() => {})
    },
    toUrl (url, params) {
      if (this.customerInfo.isAllot === 0 || (params.auth && !this.checkPer(['admin', params.auth]))) {
        Toast(this.$t('tips.noPermissionYet'))
        return
      }
      let pageUrl = url
      if (url === '/eventDetail') {
        pageUrl = `${url}?eventId=${params.sourceId}&pageType=`
        this.SET_EVENTINFO({ ...this.eventInfo, eventId: params.sourceId })
      } else if (['Mapping'].includes(params.label)) {
        pageUrl = `${url}?customerId=${this.customerInfo.id}&pageType=storeMaintain`
      } else if (['Event Invite'].includes(params.label) || url === '/createEvent') {
        pageUrl = `${url}?customerId=${this.customerInfo.id}&customerName=${this.customerInfo.customerName}&pageType=storeMaintain&eventType=1`
      } else if (['Event Execute', 'Incentive'].includes(params.label)) {
        if (['Incentive'].includes(params.label) && !this.checkPer(['admin', 'app:incentive'])) {
          Toast(`${this.$t('tips.pending')}...`)
          return
        }
        pageUrl = `${pageUrl}?customerId=${this.customerId}&customerName=${this.customerInfo.customerName}&pageType=storeMaintain`
      } else if (['Visit', 'Reorder'].includes(params.label)) {
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        this.pageType = params.label === 'Reorder' ? 'Reorder' : 'storeMaintain'
        arsVisitLastApi(this.customerId, params.label === 'Reorder' ? '2' : '0').then(res => {
          Toast.clear()
          this.currentVisitInfo = res.data
          if (res.data.lastType === 0) {
            this.$router.push(`${pageUrl}?customerId=${this.customerId}`)
          } else {
            this.$refs.xuVisitDialogRef.dialogShow = true
          }
        })
        return
      }
      if (!pageUrl) return
      this.$router.push(pageUrl)
    },
    imgPreview (url) {
      ImagePreview([url])
    },
    getCurrentLoc () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      const currentTimeLoc =
        JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
      this.getlocation(currentTimeLoc.lat, currentTimeLoc.lng, this.eventInfoObj.address)
    },
    getlocation (lat, lng, toAddress) {
      // 根据经纬度获取位置
      new google.maps.Geocoder().geocode(
        {
          location: new google.maps.LatLng(lat, lng)
        },
        function geoResults (results, status) {
          Toast.clear()
          // 这里处理结果和上面一模一样
          if (status === google.maps.GeocoderStatus.OK) {
            window.location.href = `https://www.google.com/maps/dir/?api=1&dir_action=navigate&origin=${results[0].formatted_address}&destination=${toAddress}&waypoints=`
          } else {
            console.log('：error ' + status)
          }
        }
      )
    },
    toPage (url) {
      this.$router.push(url)
    },
    handleOper (type) {
      if (type === 'giveup') {
        this.giveUpShow = true
        this.giveUpReason = ''
      } else if (type === 'cancel') {
        this.giveUpShow = false
      } else if (type === 'submit') {
        if (this.giveUpReason === '') {
          Toast(this.$t('tips.reasonIsRequired'))
          return ''
        }
        this.giveUpShow = false
        Dialog.confirm({
          message: `<div><i class="van-icon van-icon-info-o" style="font-size: 48px; color: #c4200b; margin-bottom: 15px;"></i><div style="line-height: 1.5;">${this.$t('tips.messageFortySeven')}.</div></div>`,
          confirmButtonText: this.$t('button.confirm'),
          cancelButtonText: this.$t('button.cancel'),
          confirmButtonColor: '#c4200b'
        })
          .then(() => {
            Toast.loading({
              message: this.$t('shared.loading'),
              forbidClick: true,
              duration: 0
            })
            const data = {
              sourceId: this.customerInfo.id,
              submitNote: this.giveUpReason
            }
            auditGiveUpCustomerAuditApi(data).then(res => {
              Toast.clear()
              Notify({ type: 'success', message: this.$t('shared.success'), duration: 1500 })
              this.getCustomerInfo()
            })
          })
          .catch(() => {
            // on cancel
          })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.choice-work-item {
  padding-top: 10px;
  .right-header {
    font-size: 14px;
    color: #307bff;
  }
  .header-section {
    display: flex;
    margin: 10px;
    padding: 10px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    border-radius: 8px;
    .store-img {
      width: 62px;
      height: 62px;
      object-fit: cover;
    }
    .custom-img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 53px;
      height: 53px;
      object-fit: cover;
    }
    .mark-img {
      position: absolute;
      bottom: 0;
      right: 4px;
      width: 24px;
      height: 30px;
      transform: rotate(-26deg);
    }
    .img-bc {
      position: relative;
      width: 65px;
      height: 65px;
      background: url('~@/assets/images/u91.png') no-repeat;
      background-size: 65px 65px;
    }
    .right-info {
      flex: 1;
      margin-left: 10px;
      .store-name {
        max-width: 240px;
        font-size: 16px;
        font-weight: bold;
      }
      .tag-ba {
        display: flex;
        align-items: center;
        width: 240px;
        margin-top: 2px;
        margin-bottom: 5px;
        .tag-info {
          max-width: 76px;
          padding: 3px 5px;
          text-align: center;
          font-size: 10px;
          border: 1px solid #ee541b;
          color: #ee541b;
          background-color: #eccfc4;
          margin-right: 6px;
        }
        .tag0 {
          border: 1px solid #0db00b;
          color: #0db00b;
          background-color: #abdaaa;
        }
        .tag2 {
          border: 1px solid #dc851f;
          color: #dc851f;
          background-color: #f0e2d1;
        }
        .tag3 {
          border: 1px solid #7f7f7f;
          color: #7f7f7f;
          background-color: #dcdcdc;
        }
        .ba-name {
          flex: 1;
        }
      }
      .product-type {
        display: flex;
        align-items: center;
        margin-top: 2px;
        font-size: 12px;
        .type-info {
          max-width: 240px;
          padding: 0px 3px;
          border: 1px solid #307bff;
          color: #307bff;
          border-radius: 3px;
        }
      }
      .last-activity {
        margin-top: 6px;
        .font-color {
          color: #307bff;
          font-weight: bold;
        }
      }
      .info-row {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        line-height: 1.4;
        margin-top: 10px;

        .row-icon {
          width: 13px;
          height: 13px;
          margin-right: 6px;
          object-fit: contain;
        }
        .navigate-info {
          display: flex;
          align-items: center;
          padding: 4px 4px;
          font-size: 10px;
          border-radius: 3px;
          color: #fff;
          background-color: #307bff;
        }
      }
    }
  }
  .menu-content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 10px 20px;
    padding-bottom: 0;
    .work-item {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 31%;
      margin-bottom: 20px;
      .work-icon {
        width: 76px;
        height: 76px;
        border-radius: 16px;
        .img-icon {
          width: 100%;
          height: 100%;
        }
      }
      .work-text {
        color: #307bff;
        font-weight: bold;
        font-size: 15px;
        margin-top: 10px;
      }
      // &::after {
      //   content: '';
      //   position: absolute;
      //   top: 0;
      //   left: 0;
      //   width: 100%;
      //   height: 100%;
      //   background: rgba(133, 133, 136, 0.5);
      // }
    }
  }
  .give-up-content {
    padding: 0 36px;
    padding-bottom: 23px;
    .fq-btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 46px;
      background-color: #fbdcda;
      border: 1px solid #c4200b;
      border-radius: 5px;
      font-size: 14px;
      color: #c4200b;
    }
    .review {
      background-color: #dfdfdf;
      color: #555555;
      border: 1px solid #555555;
      >span:nth-child(2) {
        font-size: 10px;
      }
    }
  }
  .line-split {
    width: 100%;
    height: 3px;
    background-color: #f5f5f9;
  }
  .log-title {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    color: #307bff;
    margin-top: 20px;
    margin-bottom: 10px;
    &::before {
      content: '';
      width: 6px;
      height: 12px;
      margin-right: 3px;
      background-color: #307bff;
    }
  }
  .log-content {
    padding: 0 10px;
    .steps-content {
      font-size: 11px;
      .step-title {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: bold;
      }

      .step-item {
        display: flex;
        align-items: center;
        > span {
          padding-top: 4px;
        }
        .store-name {
          flex: 1;
        }
      }
      /deep/.van-step {
        color: #000;
      }
      /deep/.van-step--vertical {
        padding-top: 5px;
        padding-bottom: 5px;
        padding-right: 0;
        &:first-child {
          padding-top: 5px;
        }

        font-size: 11px;
        &:last-child {
          .van-step__circle {
            display: none;
          }
        }
        .van-step__icon--active {
          color: #307bff;
        }
        .van-step__title--active,
        .van-step__icon--finish,
        .van-step__title--finish {
          color: #000;
        }
        &::after {
          border: none;
        }
        .van-step__circle-container {
          top: 15px;
        }
      }
    }
    /deep/.van-steps--vertical {
      padding: 0 0 0 21px;
      .van-step__circle,
      .van-step__line {
        width: 2px;
        background-color: #307bff;
      }
      .van-step__line {
        left: -16px;
      }
      .van-step__circle {
        width: 8px;
        height: 8px;
      }
    }
  }
}
.fq-dialog-content {
  width: 100%;
  padding: 26px 20px;
  font-size: 12px;
  color: #333;
  .dialog-title {
    font-size: 15px;
    text-align: center;
    font-weight: bold;
  }
  .customer-name {
    margin-top: 16px;
    margin-bottom: 10px;
  }
  .form-item {
    margin-bottom: 10px;
    .form-label {
      margin-bottom: 5px;
    }
    .custom-field {
      padding: 5px 10px;
      background: #fff;
      border: 1px solid #aaa;
      border-radius: 4px;
    }
    .field-textarea {
      min-height: 100px;
    }
  }
  .tips-item {
    display: flex;
    color: #c4200b;
    .info-icon {
      margin-top: 1px;
      margin-right: 3px;
    }
  }
}
.popup-btn {
  display: flex;
  .cancel-btn,
  .submit-btn {
    width: 50%;
    text-align: center;
    padding: 10px 0;
    border: 1px solid #ebedf0;
    border-bottom: none;
  }
  .cancel-btn {
    border-left: none;
  }
  .submit-btn {
    border-right: none;
    color: #c4200b;
  }
}
/deep/.van-popover__action {
  width: 200px;
}
/deep/.van-popover__action-text {
  text-align: left;
}
</style>
